import React from 'react';

import SpecialOffers from '../SpecialOffers/SpecialOffers';

const ModuleSpecialOffers = ({
  loading,
  discounted,
  primaryColor,
  uiVariantThumbnail,
}) => {
  return (
    <SpecialOffers
      products={discounted}
      loading={loading}
      primaryColor={primaryColor}
      uiVariantThumbnail={uiVariantThumbnail}
    />
  );
};

export default ModuleSpecialOffers;
